import { render } from "./DepositTable.vue?vue&type=template&id=e5b3a134&scoped=true"
import script from "./DepositTable.vue?vue&type=script&lang=js"
export * from "./DepositTable.vue?vue&type=script&lang=js"

import "./DepositTable.vue?vue&type=style&index=0&id=e5b3a134&scoped=true&lang=css"

import exportComponent from "/Users/maikejun/Desktop/code/dk/preSaleNew/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5b3a134"]])

export default __exports__